/**
 * Copyright (c) 2019-2020 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { ValueCell } from '../../mol-util/value-cell';
import { Vec2 } from '../../mol-math/linear-algebra';
import { createTextureImage } from '../../mol-gl/renderable/util';
export function applyTransparencyValue(array, start, end, value) {
  for (var i = start; i < end; ++i) {
    array[i] = value * 255;
  }

  return true;
}
export function getTransparencyAverage(array, count) {
  var sum = 0;

  for (var i = 0; i < count; ++i) {
    sum += array[i];
  }

  return sum / (255 * count);
}
export function clearTransparency(array, start, end) {
  array.fill(0, start, end);
}
export function createTransparency(count, transparencyData) {
  var transparency = createTextureImage(Math.max(1, count), 1, Uint8Array, transparencyData && transparencyData.tTransparency.ref.value.array);

  if (transparencyData) {
    ValueCell.update(transparencyData.tTransparency, transparency);
    ValueCell.update(transparencyData.uTransparencyTexDim, Vec2.create(transparency.width, transparency.height));
    ValueCell.updateIfChanged(transparencyData.dTransparency, count > 0);
    ValueCell.updateIfChanged(transparencyData.transparencyAverage, getTransparencyAverage(transparency.array, count));
    return transparencyData;
  } else {
    return {
      tTransparency: ValueCell.create(transparency),
      uTransparencyTexDim: ValueCell.create(Vec2.create(transparency.width, transparency.height)),
      dTransparency: ValueCell.create(count > 0),
      transparencyAverage: ValueCell.create(0)
    };
  }
}
var emptyTransparencyTexture = {
  array: new Uint8Array(1),
  width: 1,
  height: 1
};
export function createEmptyTransparency(transparencyData) {
  if (transparencyData) {
    ValueCell.update(transparencyData.tTransparency, emptyTransparencyTexture);
    ValueCell.update(transparencyData.uTransparencyTexDim, Vec2.create(1, 1));
    return transparencyData;
  } else {
    return {
      tTransparency: ValueCell.create(emptyTransparencyTexture),
      uTransparencyTexDim: ValueCell.create(Vec2.create(1, 1)),
      dTransparency: ValueCell.create(false),
      transparencyAverage: ValueCell.create(0)
    };
  }
}